import React, { useState, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, CardHeader, Avatar, Container } from "@material-ui/core";
import TicketsListCustom from "../TicketsListCustom";
import UserStatusIcon from "../UserModal/statusIcon";

const useStyles = makeStyles((theme) => ({
  changeWarap: {
    width: 'auto',
    padding: 0,
    margin: 0
  },
  CardHeader: {
    width: "380px",
    height: "78px"
  },
  card: {
    height: "330px",
    width: "380px",
    margin: "3px",
    borderRadius: "5px",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const UserTicketsCard = ({ user }) => {
  const classes = useStyles();
  const [openCount, setOpenCount] = useState(0);
  
  const selectedQueueIds = useMemo(() => {
    return user?.queues?.map((q) => q.id) || [];
  }, [user?.queues]);

  if (!user?.tickets?.length) return null;

  return (
    <Container className={classes.changeWarap} key={user.id}>
      <Paper className={classes.CardHeader}>
        <CardHeader
          avatar={<Avatar src={user.avatar} alt={user.name} />}
          title={
            <span>
              {user.name}
              <UserStatusIcon user={user} />
              <div>Atendimentos: {openCount}</div>
            </span>
          }
        />
      </Paper>
      <Paper className={classes.card}>
        <div>
          {user && <TicketsListCustom
            status="open"
            userFilter={user.id}
            showAll={false}
            updateCount={setOpenCount}
            selectedQueueIds={selectedQueueIds}
            queues={user.queues}
            user={user}
          />}
        </div>
      </Paper>
    </Container>
  );
};

export default UserTicketsCard;
